import { Component, Input } from "@angular/core";
import { CardLoaderSize, DualCardData } from "../card-types";

@Component({
  selector: "billing-dual-card",
  templateUrl: "./billing-dual-card.component.html",
  styleUrls: ["../../dashboard-section.scss", "../../dashboard-section-v2.scss"],
  styles: [":host { display: contents; }"],
})
export class BillingDualCardComponent {
  @Input() card: DualCardData;
  @Input() loading: boolean = false;
  @Input() isReport: boolean = false;
  cardLoaderSize = CardLoaderSize;

  get subtitleLoading(): boolean {
    return !this.isReport && this.card.subtitleLoading === true;
  }

  get isLoading(): boolean {
    return this.loading || this.subtitleLoading;
  }
}
